import sanityTest from './sanitytest/sanitytest';
import createPrimitive from './primitives/createprimitive';
import * as primitives from './primitives/primitives';
import mdlStructure from './mdlstructure';

export default {
  sanityTest,
  createPrimitive,
  primitives,
  mdlStructure,
};
